import FormSkeleton from '../FormSection/FormSkeleton';
import './ContactLayoutSkeleton.scss';

const ContactLayoutSkeleton = ({ type = 'contact' }) => {
    const isContactType = type === 'contact';

    return (
        <div className="contact__wrapper__skeleton">
            <div className="left__side__services__section__skeleton">
                <div className="contact__content__skeleton">
                    <div className="services__accent__skeleton"></div>
                    <div className="services__title__skeleton"></div>

                    {isContactType ? (
                        <>
                            {[...Array(3)].map((_, index) => (
                                <div key={index} className="services__subtitle__skeleton"></div>
                            ))}
                            <div className="services__subtitle__skeleton--primary"></div>
                            <div className="services__subtitle__skeleton"></div>
                        </>
                    ) : (
                        <>
                            {[...Array(3)].map((_, index) => (
                                <div key={index} className="services__subtitle__skeleton"></div>
                            ))}
                            <div className="services__subtitle__skeleton--primary"></div>
                        </>
                    )}

                    {isContactType && (
                        <>
                            <div className="services__button__skeleton"> </div>
                            <div className="services__button__skeleton btn__media__skeleton"></div>
                            <div className="services__subtitle__unique__skeleton"></div>
                            <div className="services__button--primary__skeleton"></div>
                        </>
                    )}
                </div>
            </div>
            <div className="right__side__contact__section__skeleton">
                <div className='contact__section__wrapper__title__skeleton'>
                    <div className='contact__section__title__skeleton'></div>
                    <div className="contact__section__subtitle__skeleton"></div>
                        <div className="contact__section__subtitle__skeleton--primary"></div>
                </div>
                <FormSkeleton />
            </div>
        </div>
    );
};

export default ContactLayoutSkeleton;